<!-- <div class="ridango-form-field-wrapper">
    <div class="ridango-form-field-flex" #connectionContainer
        (click)="_control.onContainerClick && _control.onContainerClick($event)">
        <ng-container *ngIf="appearance == 'outline'">
            <div class="ridango-form-field-outline">
                <div class="ridango-form-field-outline-start"></div>
                <div class="ridango-form-field-outline-gap"></div>
                <div class="ridango-form-field-outline-end"></div>
            </div>
            <div class="ridango-form-field-outline ridango-form-field-outline-thick">
                <div class="ridango-form-field-outline-start"></div>
                <div class="ridango-form-field-outline-gap"></div>
                <div class="ridango-form-field-outline-end"></div>
            </div>
        </ng-container>

        <div class="ridango-form-field-prefix" *ngIf="_prefixChildren.length">
            <ng-content select="[ridangoPrefix]"></ng-content>
        </div>

        <div class="ridango-form-field-infix" #inputContainer>
            <ng-content></ng-content>

            <span class="ridango-form-field-label-wrapper">
                <label class="ridango-form-field-label" [id]="_labelId" [attr.for]="_control.id"
                    [attr.aria-owns]="_control.id" [class.ridango-empty]="_control.empty && !_shouldAlwaysFloat"
                    [class.ridango-form-field-empty]="_control.empty && !_shouldAlwaysFloat" #label
                    *ngIf="_hasFloatingLabel()" [ngSwitch]="_hasLabel()">
                    <ng-container *ngSwitchCase="false">
                        <ng-content select="ridango-placeholder"></ng-content>
                        <span>{{_control.placeholder}}</span>
                    </ng-container>

                    <ng-content select="ridango-label" *ngSwitchCase="true"></ng-content>
                    <span class="ridango-placeholder-required ridango-form-field-required-marker" aria-hidden="true"
                        *ngIf="!hideRequiredMarker && _control.required && !_control.disabled">&#32;*</span>
                </label>
            </span>
        </div>

        <div class="ridango-form-field-suffix" *ngIf="_suffixChildren.length">
            <ng-content select="[ridangoSuffix]"></ng-content>
        </div>
    </div>
    <div class="ridango-form-field-underline" #underline *ngIf="appearance != 'outline'">
        <span class="ridango-form-field-ripple"></span>
    </div>

    <div class="ridango-form-field-subscript-wrapper" [ngSwitch]="_getDisplayedMessages()">
        <div *ngSwitchCase="'error'">
            <ng-content select="ridango-error"></ng-content>
        </div>
        <div class="ridango-form-field-hint-wrapper" *ngSwitchCase="'hint'">
            <div *ngIf="hintLabel" [id]="_hintLabelId" class="ridango-hint">{{hintLabel}}</div>
            <ng-content select="ridango-hint:not([align='end'])"></ng-content>
            <div class="ridango-form-field-hint-spacer"></div>
            <ng-content select="ridango-hint[align='end']"></ng-content>
        </div>
    </div>
</div> -->

<div class="ridango-form-field-wrapper">
    <div
        class="ridango-form-field-flex"
        #connectionContainer
        (click)="_control.onContainerClick && _control.onContainerClick($event)"
        (keydown.enter)="_control.onContainerClick && _control.onContainerClick($event)"
        (keydown.enter)="_control.onContainerClick && _control.onContainerClick($event)"
    >
        <!-- Outline used for outline appearance. -->
        <ng-container *ngIf="appearance == 'outline'">
            <div class="ridango-form-field-outline">
                <div class="ridango-form-field-outline-start"></div>
                <div class="ridango-form-field-outline-gap"></div>
                <div class="ridango-form-field-outline-end"></div>
            </div>
            <div class="ridango-form-field-outline ridango-form-field-outline-thick">
                <div class="ridango-form-field-outline-start"></div>
                <div class="ridango-form-field-outline-gap"></div>
                <div class="ridango-form-field-outline-end"></div>
            </div>
        </ng-container>

        <div class="ridango-form-field-prefix" *ngIf="_prefixChildren.length">
            <ng-content select="[ridangoPrefix]"></ng-content>
        </div>

        <div class="ridango-form-field-infix" #inputContainer>
            <span class="ridango-form-field-label-wrapper">
                <!-- We add aria-owns as a workaround for an issue in JAWS & NVDA where the label isn't
             read if it comes before the control in the DOM. -->

                <!-- [class.ridango-accent]="color == 'accent'" [class.ridango-warn]="color == 'warn'" -->
                <label
                    class="ridango-form-field-label"
                    (cdkObserveContent)="updateOutlineGap()"
                    [cdkObserveContentDisabled]="appearance != 'outline'"
                    [id]="_labelId"
                    [attr.for]="_control.id"
                    [attr.aria-owns]="_control.id"
                    [class.ridango-empty]="_control.empty && !_shouldAlwaysFloat"
                    [class.ridango-form-field-empty]="_control.empty && !_shouldAlwaysFloat"
                    #label
                    *ngIf="_hasFloatingLabel()"
                    [ngSwitch]="_hasLabel()"
                >
                    <!-- @breaking-change 8.0.0 remove in favor of ridango-label element an placeholder attr. -->
                    <ng-container *ngSwitchCase="false">
                        <ng-content select="ridango-placeholder"></ng-content>
                        <span>{{ _control.placeholder }}</span>
                    </ng-container>

                    <ng-content select="ridango-label" *ngSwitchCase="true"></ng-content>

                    <!-- @breaking-change 8.0.0 remove `ridango-placeholder-required` class -->
                    <span
                        class="ridango-placeholder-required ridango-form-field-required-marker"
                        aria-hidden="true"
                        *ngIf="!hideRequiredMarker && _control.required && !_control.disabled"
                        >&#32;*</span
                    >
                </label>
            </span>

            <ng-content></ng-content>
        </div>

        <div class="ridango-form-field-suffix" *ngIf="_suffixChildren.length">
            <ng-content select="[ridangoSuffix]"></ng-content>
        </div>
    </div>

    <!-- Underline used for legacy, standard, and box appearances. -->
    <!-- [class.ridango-accent]="color == 'accent'" [class.ridango-warn]="color == 'warn'" -->
    <div class="ridango-form-field-underline" #underline *ngIf="appearance != 'outline'">
        <span class="ridango-form-field-ripple"></span>
    </div>
    <!-- [@transitionMessages]="_subscriptAnimationState" -->
    <div class="ridango-form-field-subscript-wrapper" [ngSwitch]="_getDisplayedMessages()">
        <div *ngSwitchCase="'error'">
            <ng-content select="ridango-error"></ng-content>
        </div>

        <!-- [@transitionMessages]="_subscriptAnimationState" -->
        <div class="ridango-form-field-hint-wrapper" *ngSwitchCase="'hint'">
            <!-- TODO(mmalerba): use an actual <ridango-hint> once all selectors are switched to ridango-* -->
            <div *ngIf="hintLabel" [id]="_hintLabelId" class="ridango-hint">{{ hintLabel }}</div>
            <ng-content select="ridango-hint:not([align='end'])"></ng-content>
            <div class="ridango-form-field-hint-spacer"></div>
            <ng-content select="ridango-hint[align='end']"></ng-content>
        </div>
    </div>
</div>
